import React from 'react';
import StyledBreadcrumbs from '../../../../styled/Breadcrumbs';
import useBreadcrumbs from './useBreadcrumbs';

const Breadcrumbs = () => {
  const items = useBreadcrumbs();

  if (!items?.length) {
    return null;
  }

  return <StyledBreadcrumbs items={items} />;
};

export default Breadcrumbs;
